import { defineMessages } from 'react-intl';

export default defineMessages({
    vinNumberLabel: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.VIN Number',
        defaultMessage: 'VIN'
    },
    enterVin: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.Enter VIN',
        defaultMessage: 'Enter VIN'
    },
    LOOKUPVINBtn: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.LOOKUP VIN',
        defaultMessage: 'LOOKUP VIN'
    },
    lookupVin: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.Lookup VIN',
        defaultMessage: 'Lookup VIN'
    },
    verifyVin: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.VERIFY VIN',
        defaultMessage: 'VERIFY VIN'
    },
    duplicatedVin: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.VIN number already exists on another vehicle, please update VIN',
        defaultMessage: 'VIN already exists on another vehicle, please update VIN'
    },
    vinResponseInvalidPleaseTryAgain: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.invalidVINPleaseTryAgain',
        defaultMessage: 'Invalid VIN. Please try again.'
    },
    vinRequired: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.VIN required. Must be 17 digits if 1981 and newer.',
        defaultMessage: 'VIN required. Must be 17 digits if 1981 and newer.'
    },
    thisIsRequiredErrorMsg: {
        id: 'ml.quoteandbind.common.vehiclevinlookup.This is required',
        defaultMessage: 'This is required'
    }
});
